import { FunctionalComponent } from 'preact'
import { Timezone } from './types'

export interface DropdownTextProps {
  timezones: Timezone[]
  selected?: Timezone
}

export const DropdownText: FunctionalComponent<DropdownTextProps> = ({ timezones, selected }) => {
  if (timezones.length === 0) {
    return <div className='timezone-selector-placeholder'>Loading timezones...</div>
  }
  if (selected) {
    return (
      <span className='selected'>
        <div className='truncated'>{selected.title}</div>
      </span>
    )
  }
  return <div className='timezone-selector-placeholder'>Choose a timezone</div>
}
